import { JourneysHistoryService as HistoryService } from '../../../../main/services/Journeys/History/JourneysHistoryService';
import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import { INIT_STATE } from './constants';

import type { Rule } from '../../../../main/types/journeyTypes';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { FETCH_JOURNEY_ITERATIONS, FETCH_MAIN_ACTIVE_JOURNEY, type ReducerAction } from './actions';
import type { ReducerState } from './types';

const handler = (state: WrappedReducer<ReducerState>, action: ReducerAction): WrappedReducer<ReducerState> => {
  const { type, data } = action;
  switch (type) {
    case FETCH_MAIN_ACTIVE_JOURNEY.request: {
      return {
        ...state,
        isLoadingMainActiveJourney: true,
      };
    }
    case FETCH_MAIN_ACTIVE_JOURNEY.error: {
      return {
        ...state,
        isLoadingMainActiveJourney: false,
      };
    }
    case FETCH_MAIN_ACTIVE_JOURNEY.response: {
      return {
        ...state,
        isLoadingMainActiveJourney: false,
        mainActiveJourney: data as Rule,
      };
    }
    case FETCH_JOURNEY_ITERATIONS.request: {
      return {
        ...state,
        isLoadingIterations: true,
      };
    }
    case FETCH_JOURNEY_ITERATIONS.error: {
      return {
        ...state,
        isLoadingIterations: false,
      };
    }
    case FETCH_JOURNEY_ITERATIONS.response: {
      const iterationsReport = HistoryService.mapIterationsToReport(data as Rule[]);
      return {
        ...state,
        isLoadingIterations: false,
        iterations: iterationsReport,
      };
    }
    default: {
      return state;
    }
  }
};

const JourneysHistoryReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [],
  error: [],
});

export default JourneysHistoryReducer;
